import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  SET_UNIT_DETAILS,
  USER_MENU_DETAILS_REQUEST, 
  USER_MENU_DETAILS_SUCCESS, 
  USER_MENU_DETAILS_FAILURE, 
  NOTIFICATION_REQUEST,
  REFRESH_SESSION
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = (history,reason) => {
  return {
    type: LOGOUT_USER,
    payload: { history,reason },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

// Action to initiate validation
export const userMenuDetailsRequest = (user, history) => {
  return {
    type: USER_MENU_DETAILS_REQUEST,
    payload: { user, history },
  }
}

// Action when validation is successful
export const userMenuDetailsSuccess = (response) => ({
  type: USER_MENU_DETAILS_SUCCESS,
  payload: response,
});

// Action when validation fails
export const userMenuDetailsFailure = (error) => ({
  type: USER_MENU_DETAILS_FAILURE,
  payload: error,
});

export const setUnitDetails = (unitDetails) => ({
  type: SET_UNIT_DETAILS,
  payload: unitDetails,
});

export const notificationRequest = (payload) => {
  return {
    type: NOTIFICATION_REQUEST,
    payload,
  };
};

export const refreshSession = (payload) => {
  return {
    type: REFRESH_SESSION,
    payload,
  };
};